import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex border-r flex-col xl:flex-row pt-4 xl:pt-0" }
const _hoisted_2 = { class: "xl:hidden px-4" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "relative flex-col bg-white hidden overflow-y-auto xl:block w-[250px]" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = ["onClick", "title"]

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import { computed } from "vue";
import { Report, ReportPlotType } from "@/types/Report";
import reportIconsConfig from "./reportIconsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSidebar',
  props: {
    reports: {},
    selectedReport: {}
  },
  emits: ["selectReport"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const switchToReport = (report: Report) => {
  if (report && report._id !== props.selectedReport?._id) {
    emit("selectReport", report);
  }
};

const handleSelectChange = (event: Event) => {
  const reportId = (event.target as HTMLInputElement).value;
  const report = props.reports.find((f) => f._id === reportId);
  if (report) {
    switchToReport(report);
  }
};

const reportsByType = computed(() => {
  const reportsType = props.reports.reduce((acc, report) => {
    acc[report.type] = acc[report.type] || [];
    acc[report.type].push(report);
    return acc;
  }, {} as Record<ReportPlotType, Report[]>);

  const sortedKeys = Object.keys(reportsType).sort() as ReportPlotType[];
  return sortedKeys.reduce((acc: Record<ReportPlotType, Report[]>, key: ReportPlotType) => {
    acc[key] = reportsType[key];
    return acc;
  }, {} as Record<ReportPlotType, Report[]>);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "w-auto oai-inputs",
        onChange: handleSelectChange
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
          return (_openBlock(), _createElementBlock("option", {
            key: report.name,
            value: report._id,
            selected: _ctx.selectedReport?._id === report._id
          }, _toDisplayString(report.name), 9, _hoisted_3))
        }), 128))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportsByType.value, (reports, type) => {
        return (_openBlock(), _createElementBlock("div", {
          key: type,
          class: "border-b"
        }, [
          _createVNode(_unref(Disclosure), { defaultOpen: "" }, {
            default: _withCtx(({ open }) => [
              _createVNode(_unref(DisclosureButton), {
                class: _normalizeClass(["flex items-center justify-between bg-gray-100 px-2 py-1 w-full border-l-4 font-medium", [open && 'bg-gray-100', _ctx.selectedReport?.type === type && '']])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(reportIconsConfig)[type].icon), {
                      class: _normalizeClass([
                  _ctx.selectedReport?.type === type ? _unref(reportIconsConfig)[type].style : 'stroke-gray-600',
                  'h-5 w-5 flex-shrink-0',
                ])
                    }, null, 8, ["class"])),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t(`analytics.reports.${type}_plot`)), 1)
                  ]),
                  _createVNode(_unref(ChevronLeftIcon), {
                    class: _normalizeClass([open ? '-rotate-90 transform' : '', "w-4"])
                  }, null, 8, ["class"])
                ]),
                _: 2
              }, 1032, ["class"]),
              _createVNode(_unref(DisclosurePanel), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports, (report) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([_ctx.selectedReport?._id === report._id && 'border-l-yellow text-oaiGray-400 ', "py-2 px-2 lg:pl-6 lg:py-4 border-l-4 cursor-pointer truncate border-t text-gray-600 text-xs break-words"]),
                      key: report.name,
                      onClick: ($event: any) => (switchToReport(report)),
                      title: report.name
                    }, _toDisplayString(report.name), 11, _hoisted_6))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}
}

})